import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DropdownLayout_1 from "../../../../components/Dropdown/DropdownLayout_1";
import DropdownVoucherDynamicInput from "../../../../components/Dropdown/DropdownVoucherDynamicInput";
import DropdownForItemLedgerDynamic from "../../../../components/Dropdown/DropdownForItemLedgerDynamic";
import { dummy_units_array } from "../../../../components/Dummi_Data";
import { currencyFormate, removeCurrencyComma } from "../../../../components/Date_Formate_Utilitiy/Index";



export const PaymentAllocation = ({
  data,
  setData,
  handleChange,
  handleFocus,
  handleBlur,
  inputRefs,
  itemData,
  dropList,
  narr_ref,
  itemLedgerData,
  handleDropdownDynamicClick
}) => {
  const modal_state = useSelector((state) => state.common.modal_state);
  
  // Calculate current total allocated amount
//   const currentTotalAllocated = data?.payment_allocation?.reduce((sum, item) => {
//     const allocatedAmount = parseFloat(removeCurrencyComma(item?.payment_ledger_amount)) || 0;
//     return sum + allocatedAmount;
//   }, 0) || 0;

  // Check if total amount is reached
//   const isTotalReached = data?.total_amount && currentTotalAllocated >= data.total_amount;

  return (
    <div
      className="row m-0 p-0"
      style={{ height: "12vh", overflowY: "scroll" }}
    >
              {/* Status Indicator */}
      {/* {data?.total_amount > 0 && (
        <div className="col-12 mb-1">
          <div className="row">
            <div className="col-12 text-center">
              <span 
                style={{ 
                  fontSize: 11, 
                  padding: '2px 8px', 
                  borderRadius: '3px',
                  backgroundColor: isTotalReached ? '#d4edda' : '#fff3cd',
                  color: isTotalReached ? '#155724' : '#856404',
                  border: `1px solid ${isTotalReached ? '#c3e6cb' : '#ffeaa7'}`
                }}
              >
                {isTotalReached 
                  ? `✓ Total amount allocated (${currencyFormate(data.total_amount)})` 
                  : `Remaining: ${currencyFormate(data.total_amount - currentTotalAllocated)}`
                }
              </span>
            </div>
          </div>
        </div>
      )} */}

      <div className="col-12">
        <div className="row">
          {data?.payment_allocation?.map((item, index) => {
            return (
              <div
                key={index}
                className={`col-12`}
                style={{ height: 19.5, backgroundColor: "transparent" }}
              >
                <div className="row" style={{ height: 19.5 }}>
              
                  <div
                    className={`col-4 m-0  p-0  container_of_voucher_dynamic_input`}
                  >
                    <input
                      type="text"
                      name={`payment_ledger_account${index}`}
                      ref={(el) => {
                        inputRefs.current[`payment_ledger_account${index}`] = el;
                      }}
                      className="voucher_entry_account_input"
                      onChange={(e) =>
                        handleChange(e, index, "payment_ledger_account", e.target.value)
                      }
                      onKeyUp={(e) =>
                        handleChange(e, index, "payment_ledger_account", e.target.value)
                      }
                      onFocus={(e) =>
                        handleFocus(e, index, "payment_ledger_account", e.target.value)
                      }
                      onBlur={(e) =>
                        handleBlur(e, index, "payment_ledger_account", e.target.value)
                      }
                      value={data?.payment_allocation[index]?.payment_ledger_account || ""}
                    />
                    {modal_state[`payment_ledger_account${index}`] && (
                      <DropdownVoucherDynamicInput
                        title={"List of Ledger Account"}
                        state={modal_state[`payment_ledger_account${index}`]}
                        data={data}
                        setData={setData}
                        input_value={item?.payment_ledger_account}
                        input_key={"payment_ledger_account"}
                        input_id={"payment_ledger_account_id"}
                        input_blc={""}
                        rawData={itemLedgerData}
                        index={index}
                        ref={inputRefs.current[`payment_ledger_account${index}`]}
                        refs={inputRefs}
                        narr_ref={narr_ref}
                        isDynamic={true}
                        handleDropdownClick={handleDropdownDynamicClick}
                      />
                    )}
                  </div>
                  <div
                    className={`col-4 m-0  p-0  container_of_voucher_dynamic_input`}
                    style={{ width: "5%" }}
                  ></div>
                  {data?.payment_allocation[index]?.payment_ledger_account !== "" ? (
                      <div
                        className={`col m-0 p-0 container_of_voucher_dynamic_input`}
                      >
                        <input
                          type="text"
                          style={{ 
                            textAlign: "right", 
                            paddingRight: 5,
                          }}
                          name={`payment_ledger_amount${index}`}
                          ref={(el) => {
                            inputRefs.current[`payment_ledger_amount${index}`] = el;
                          }}
                          className="voucher_entry_account_input"
                          onChange={(e) =>
                            handleChange(e, index, "payment_ledger_amount", e.target.value)
                          }
                          onKeyUp={(e) =>
                            handleChange(e, index, "payment_ledger_amount", e.target.value)
                          }
                          onFocus={(e) =>
                            handleFocus(e, index, "payment_ledger_amount", e.target.value)
                          }
                          onBlur={(e) =>
                            handleBlur(e, index, "payment_ledger_amount", e.target.value)
                          }
                          value={data?.payment_allocation[index]?.payment_ledger_amount || ""}
                        //   disabled={isTotalReached}
                        />
                      </div>
                  ) : null}
                </div>
              </div>
            );
          })}
    
        </div>
      </div>
    </div>
  );
};
